import { render, staticRenderFns } from "./Pesanan.vue?vue&type=template&id=0a1e743a&"
import script from "./Pesanan.vue?vue&type=script&lang=js&"
export * from "./Pesanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports